import { render } from "./PostItem.vue?vue&type=template&id=1cadce3e"
import script from "./PostItem.vue?vue&type=script&lang=ts"
export * from "./PostItem.vue?vue&type=script&lang=ts"
script.render = render

export default script